import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalOffDaysActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/OffDays/OffDaysBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalOffDays"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalOffDays"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalOffDaysActivity)
